var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _animateTransform;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M30.5304 46.5589C31.4722 44.9733 32.5054 43.4473 33.6261 41.9928L16.6176 24.9844C13.4742 28.7159 10.7123 32.7773 8.39551 37.1128L30.5304 46.5589Z",
    fill: "#FF2F37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M24.5173 63.9197C24.8034 61.746 25.2405 59.6239 25.8168 57.5535L3.68192 48.1074C2.02081 53.1504 0.920029 58.4436 0.455078 63.9158H24.5173V63.9197Z",
    fill: "#FF2F37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M42.0856 33.5313C43.7984 32.2159 45.6026 31.0158 47.4941 29.9468L38.521 7.61328C33.6887 10.0652 29.1822 13.0616 25.0771 16.5229L42.0856 33.5313Z",
    fill: "#FF2F37"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M75.9834 24.4235C78.1571 24.7097 80.2832 25.1468 82.3497 25.723L91.7957 3.58817C86.7528 1.92706 81.4595 0.826279 75.9874 0.361328V24.4235H75.9834Z",
    fill: "#FF2F37"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M93.3457 30.4356C94.9313 31.3775 96.4533 32.4107 97.9118 33.5313L114.92 16.5229C111.189 13.3795 107.127 10.6176 102.792 8.30078L93.3457 30.4356Z",
    fill: "#FF2F37"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M58.5933 25.4687C60.3617 25.0157 62.1738 24.6659 64.0177 24.4235V0.361328C59.0543 0.78654 54.2378 1.72836 49.6201 3.13911L58.5933 25.4687Z",
    fill: "#FF2F37"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M25.5624 81.3111C25.1094 79.5427 24.7597 77.7306 24.5173 75.8867H0.455078C0.88029 80.8502 1.82211 85.6666 3.23286 90.2843L25.5624 81.3111Z",
    fill: "#FF2F37"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M123.382 24.9844L106.373 41.9928C107.688 43.7056 108.889 45.5098 109.958 47.4014L132.291 38.4282C129.839 33.5959 126.843 29.0895 123.382 24.9844Z",
    fill: "#FF2F37"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M109.469 93.252C108.527 94.8376 107.494 96.3596 106.373 97.818L123.382 114.826C126.525 111.095 129.287 107.034 131.604 102.698L109.469 93.252Z",
    fill: "#FF2F37"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M97.9124 106.279C96.1997 107.595 94.3955 108.795 92.5039 109.864L101.477 132.197C106.309 129.745 110.816 126.749 114.921 123.288L97.9124 106.279Z",
    fill: "#FF2F37"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M115.481 75.8906C115.195 78.0644 114.758 80.1865 114.182 82.2569L136.316 91.7029C137.978 86.66 139.078 81.3667 139.543 75.8946H115.481V75.8906Z",
    fill: "#FF2F37"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M114.436 58.5005C114.889 60.2689 115.238 62.081 115.481 63.9249H139.543C139.118 58.9615 138.176 54.1451 136.765 49.5273L114.436 58.5005Z",
    fill: "#FF2F37"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M64.0145 115.387C61.8407 115.101 59.7186 114.664 57.6482 114.088L48.2021 136.223C53.2451 137.884 58.5384 138.985 64.0105 139.45V115.387H64.0145Z",
    fill: "#FF2F37"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M46.6517 109.375C45.0661 108.433 43.5441 107.4 42.0856 106.279L25.0771 123.288C28.8087 126.431 32.87 129.193 37.2056 131.51L46.6517 109.375Z",
    fill: "#FF2F37"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M33.626 97.8187C32.3107 96.1059 31.1105 94.3018 30.0416 92.4102L7.70801 101.383C10.1599 106.216 13.1563 110.722 16.6176 114.827L33.626 97.8187Z",
    fill: "#FF2F37"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M81.4039 114.342C79.6355 114.795 77.8234 115.145 75.9795 115.387V139.449C80.9429 139.024 85.7594 138.082 90.3771 136.671L81.4039 114.342Z",
    fill: "#FF2F37"
  })), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "0s",
    dur: "1s",
    type: "rotate",
    from: 0,
    to: 360,
    repeatCount: "indefinite"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.2f2071d314e9ce360186114d8821df5d.svg";
export { ForwardRef as ReactComponent };